module.exports = __webpack_public_path__ + "static/media/stol_i_palniki.4edef548.jpg";